/** Ventana de números de página alrededor del actual (máx `size`), para el
 *  paginador numerado. Puro y testeable. */
export function pageWindow(current: number, totalPages: number, size = 5): number[] {
  if (totalPages <= size) {
    return Array.from({ length: Math.max(0, totalPages) }, (_, i) => i + 1);
  }
  const half = Math.floor(size / 2);
  const end = Math.min(totalPages, Math.max(1, current - half) + size - 1);
  const start = Math.max(1, end - size + 1);
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
}
